import { projectDetails } from "@redux/memoizedSelectors";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { shallowEqual, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button, GenericButton } from "shared/ui-basics/buttons";
import { updateProject } from "../reducer/ProjectsActions";
import * as Style from "./SectionsStyling";

export const ProjectDetails = () => {
	const { t } = useTranslation();

	const { id, projectManagementTool, projectManagementToolLink } = useSelector(projectDetails, shallowEqual);
	const roleName = useSelector((s) => s.projects?.currentUser?.roleName)?.toLowerCase();

	const [pmt, setPmt] = useState(projectManagementTool);
	const [pmtl, setPmtl] = useState(projectManagementToolLink);
	const isViewer = roleName === "viewer";

	const handleBlur = useCallback(
		async (attribute, value) => {
			try {
				updateProject({ modifiedProject: { id, [attribute]: value }, modifiedAttribNames: [attribute] });
			} catch (error) {
				// console.error("Failed to update project:", error);
				// Handle error (e.g., show a notification)
			}
		},
		[id]
	);

	const handleCopy = useCallback(
		async (text) => {
			try {
				await navigator.clipboard.writeText(text);
				toast.success(t("COPY_LINK_SUCCESS"));
			} catch (error) {
				// console.error("Copy to clipboard failed:", error);
				// Handle error (e.g., show a notification)
			}
		},
		[t]
	);
	return (
		<Style.CustomRow className="mb-5 gx-5">
			<Style.CustomCol xs={6} className="position-relative">
				<Style.CustomLabel>{t("PROJECT_MANAGEMENT_TOOL")}</Style.CustomLabel>
				<Style.CustomInput
					variant="default"
					type="text"
					name="projectManagementTool"
					onChange={(e) => setPmt(e.target.value)}
					onBlur={() => handleBlur("projectManagementTool", pmt)}
					value={pmt || ""}
					disabled={isViewer}
				/>
			</Style.CustomCol>

			<Style.CustomCol xs={6} className="position-relative">
				<Style.CustomLabel>{t("PROJECT_MANAGEMENT_TOOL_LINK")}</Style.CustomLabel>
				<Style.CustomInput
					variant="default"
					type="text"
					name="projectManagementToolLink"
					onChange={(e) => setPmtl(e.target.value)}
					onBlur={() => handleBlur("projectManagementToolLink", pmtl)}
					value={pmtl || ""}
					disabled={isViewer}
				/>

				<Button variant="light" id="copy_button" className="position-absolute " style={{ right: "30px", top: "50%" }} onClick={() => handleCopy(pmtl)}>
					{t("ASPX_85")}
				</Button>
			</Style.CustomCol>
		</Style.CustomRow>
	);
};
